export enum ExternalSyncStatusEnum {
  NotSent = 1,
  SentToExternalSystem = 2,
  ProcessedByExternalSystem = 3,
  Pending = 4,
  InProcess = 5,
  Success = 6,
  Error = 7,
}
